import { useQuery } from "react-query";
import { notification, Typography } from "antd";
import log from "../../utils/log";
import { getProductAvailableQty } from "../../utils/product";
import useAuthStore from "../../states/useAuth";
import useDB from "../useDB";

const { Title, Text } = Typography;

const useProductQuery = (params = {}, options = {}) => {
  const { user } = useAuthStore();
  const { get } = useDB();

  // Ensure params are defined
  if (!params || Object.keys(params).length === 0) {
    throw new Error("Params are required for useProductQuery.");
  }

  // Default query options
  const defaultOptions = {
    enabled: !!params, // Only enable the query if params are defined
    staleTime: 10000, // Default stale time of 10 seconds
    onError: (error) => {
      log.debug(error);
      notification.error({
        message: (
          <Title style={{ margin: 0 }} level={4}>
            Error
          </Title>
        ),
        description: <Text strong>Please refresh this page</Text>,
      });
    },
  };

  // Merge default options with user-provided options
  const queryOptions = { ...defaultOptions, ...options };

  // Define the query function
  const fetchProductData = async () => {
    const result = await get("products/query", params);

    // Optionally filter products based on availability
    if (options.filterAvailableQty) {
      return result.filter((product) => {
        const availableQty = getProductAvailableQty(product.qty); // Calculate available quantity
        return availableQty > 0; // Keep only products with available quantity greater than 0
      });
    }

    return result;
  };

  // Use React Query's useQuery
  return useQuery(["products", params], fetchProductData, queryOptions);
};

export default useProductQuery;
